/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';



/**
 * Fonctions du plugin Idelux
 */
@Injectable({
  providedIn: 'root',
})
export class PluginIdeluxService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation pluginIdeluxHelloHelloAnonymous
   */
  static readonly PluginIdeluxHelloHelloAnonymousPath = '/api/plugin/idelux/hello-anonymous';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pluginIdeluxHelloHelloAnonymous()` instead.
   *
   * This method doesn't expect any request body.
   */
  pluginIdeluxHelloHelloAnonymous$Response(params?: {
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, PluginIdeluxService.PluginIdeluxHelloHelloAnonymousPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `pluginIdeluxHelloHelloAnonymous$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pluginIdeluxHelloHelloAnonymous(params?: {
  }): Observable<string> {

    return this.pluginIdeluxHelloHelloAnonymous$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation pluginIdeluxHelloHelloAuthenticated
   */
  static readonly PluginIdeluxHelloHelloAuthenticatedPath = '/api/plugin/idelux/hello-auth';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pluginIdeluxHelloHelloAuthenticated()` instead.
   *
   * This method doesn't expect any request body.
   */
  pluginIdeluxHelloHelloAuthenticated$Response(params?: {
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, PluginIdeluxService.PluginIdeluxHelloHelloAuthenticatedPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `pluginIdeluxHelloHelloAuthenticated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pluginIdeluxHelloHelloAuthenticated(params?: {
  }): Observable<string> {

    return this.pluginIdeluxHelloHelloAuthenticated$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

}
